import MainLayout from '@layouts/mainLayout'
import PrivateRoute from "./privateRoute"
import Dashboard from '@pages/dashboard/index'
import Page from '@pages/page'
import PostCategory from '@pages/post-category'
import Post from '@pages/post'
import ProductCategory from '@pages/product-category'
import Product from '@pages/product'
import User from '@pages/user'
import Slider from '@pages/slider'
import Promotion from '@pages/promotion'
import Role from '@pages/role'
import ChangePassword from '@pages/change-password'
import Profile from '@pages/profile'
import Options from '@pages/options'
// ==============================|| MAIN ROUTING ||============================== //


const MainRoutes = {
  path: '/',
  element: <PrivateRoute element={<MainLayout />} />,  // Truyền vào element ở đây
  children: [
    {
      path: '/',
      element: <Dashboard />
    },
    {
      path: '/profile',
      element: <Profile />
    },
    {
      path: '/options',
      element: <Options />
    },
    {
      path: '/promotion',
      element: <Promotion />
    },
    {
      path: '/slider',
      element: <Slider />
    },
    {
      path: '/change-password',
      element: <ChangePassword />
    },
    {
      path: '/page',
      element: <Page />
    },
    {
      path: '/post-category',
      element: <PostCategory />
    },
    {
      path: '/post',
      element: <Post />
    },
    {
      path: '/product-category',
      element: <ProductCategory />
    },
    {
      path: '/product',
      element: <Product />
    },
    {
      path: '/user',
      element: <User />
    },
    {
      path: '/role',
      element: <Role />
    },
  ]
}

export default MainRoutes
